export default [
  {
    path: '/Personal',
    component: () => import('@/views/PersonalCenter/Index'),
    name: 'PersonalCenter',
    meta: {
      title: '个人中心',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Contact',
    component: () => import('@/views/PersonalCenter/ContactUs/Index'),
    name: 'ContactUs',
    meta: {
      title: '联系我们',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Message',
    component: () => import('@/views/PersonalCenter/Message/Index'),
    name: 'Message',
    meta: {
      title: '消息提醒',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/SpreadAdmin',
    component: () => import('@/views/PersonalCenter/SpreadAdmin/Index'),
    name: 'SpreadAdmin',
    meta: {
      title: '推广管理',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Feedback',
    component: () => import('@/views/PersonalCenter/Feedback/Index'),
    name: 'Feedback',
    meta: {
      title: '意见反馈',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  }
]
